// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__vps_j","layout-inner":"Layout_layout-inner__3G5Az"};